<style lang="css">

</style>

<template lang="html">

<div class="">
    <el-row>
        <div style="float:left;width:70%;">

            <el-radio-group v-model="type">
                <el-radio-button label="近一周" border>近一周</el-radio-button>
                <el-radio-button label="近一月" border>近一月</el-radio-button>
            </el-radio-group>
            <el-date-picker v-model="createTime" type="datetimerange" ref="picker" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
            </el-date-picker>

            <el-select v-model="module" @change="getBuriedPointInfo()" placeholder="请选择项目">
                <el-option label="网上车展" value="网上车展">
                </el-option>
                <el-option label="本地汽车网" value="本地汽车网">
                </el-option>
            </el-select>

            <el-select v-model="position" placeholder="请选择页面或功能点" @change="onChanged">
                <el-option v-for="(item,position) in options" :label="item.describe+' - '+(item.event=='click'?'功能':'页面')" :value="position">
                </el-option>
            </el-select>
            <el-button @click="findBuriedPointEventDatas()">刷新</el-button>

            <div id="clue-data-trend-pic" v-loading="charsLoading" style="width:100%;height:800px;">
            </div>
        </div>

        <el-col style="float:right;width:25%;border-left:#eee solid 1px;">
          <mobile v-loading="mobileLoding"  element-loading-text="页面分析中..." ref="mobile" style="height:800px;" @onEdit="onEdit"></mobile>
        </el-col>
    </el-row>

    <save-x-path-dialog ref="save-x-path-dialog"></save-x-path-dialog>

</div>

</template>

<script>
import SaveXPathDialog from './children/SaveXPathDialog'
import sysModel from '@/framework/models/sysModel'
import echarts from 'echarts'
import mobile from './children/mobile'
export default {
  name: 'analysis',
  data: function () {
    return {
      type: '近一周',
      createTime: null,
      module: '本地汽车网',
      options: [],
      position: null,
      times: [],
      datas: [],
      mobileLoding: false,
      charsLoading: false
    }
  },
  components: {
    mobile,
    SaveXPathDialog
  },
  watch: {
    // position: function() {
    //   this.findBuriedPointEventDatas()
    //
    //   //改变页面展示
    //
    //   let option = this.options[this.position]
    //   this.$refs['mobile'].go(option.href)
    // },
    createTime: function (createTime) {
      if (!createTime) {
        this.chart.clear()
        return
      }

      let arr = this.getXAxis({
        tab: 0,
        startTime: this.createTime[0].getTime(),
        endTime: this.createTime[1].getTime()
      })
      this.times = arr
      this.findBuriedPointEventDatas()
    },
    type: function () {
      const end = new Date()
      const start = new Date()
      start.setTime(start.getTime() - 3600 * 1000 * 24 * (this.type == '近一周' ? 7 : 30))
      this.createTime = [start, end]
    }
  },
  mounted: function () {
    let _this = this
    const end = new Date()
    const start = new Date()
    start.setTime(start.getTime() - 3600 * 1000 * 24 * (this.type == '近一周' ? 7 : 30))
    end.setTime(end.getTime())

    let arr = this.getXAxis({
      tab: 0,
      startTime: start.getTime(),
      endTime: end.getTime()
    })

    this.createTime = [start, end]

    this.times = arr
    // this.init('clue-data-trend-pic')
    this.getBuriedPointInfo()

    self.addEventListener('message', function (event) {
      if (!event) {
        return
      }
      let data = event.data

      switch (data.command) {
        case 'changePage':

          if (!event.data.location) {
            return
          }

          _this.$refs['mobile'].setUrl(event.data.location)

          // _this.$refs['mobile'].go(event.data.location)
          //
          // if(!event.data.describe){
          //   return
          // }
          //
          // let options = _this.options
          // let position = null
          // for (var i = 0; i < options.length; i++) {
          //   let option = options[i]
          //   if(option.describe===event.data.describe){
          //     position = i
          //     break;
          //   }
          // }
          //
          //
          //
          // _this.position = position
          // _this.findBuriedPointEventDatas()
          break
        case 'buriedPoint':
          data.module = _this.module
          _this.$refs['save-x-path-dialog'].show(data)
          break
        case 'loading':
          _this.mobileLoding = true
          break
        case 'hideloading':
          _this.mobileLoding = false
          break
        case 'message':
          _this.$message.success(data.message)
          break
        default:
      }
    }, true)
  },
  methods: {
    onEdit: function () {
      let option = this.options[this.position]

      let data = {
        location: option.location,
        nativeLocation: option.nativeLocation,
        locationDescribe: option.xPath ? null : option.describe,
        xPath: option.xPath,
        nativeXPath: option.nativeXPath,
        xPathDescribe: option.xPath ? option.describe : null,
        _xPathId: option.xPath ? option._id : null,
        _locationId: option.xPath ? null : option._id
      }

      this.$refs['save-x-path-dialog'].show(data)
    },
    onChanged: function () {
      let option = this.options[this.position]
      this.$refs['mobile'].go(option.nativeLocation)

      this.findBuriedPointEventDatas()
    },
    getDateTimeByUnixTime: function (time, format = '-') {
      if (!time) {
        return '无'
      }
      let unixtime = parseInt(time)

      let localeDate = new Date(unixtime)
      let year = localeDate.getFullYear()
      let month = localeDate.getMonth() + 1
      let day = localeDate.getDate()
      let hour = localeDate.getHours()
      let minutes = localeDate.getMinutes()
      let seconds = localeDate.getSeconds()
      let dateText = year + format + (month < 10 ? '0' + month : month) + format + (day < 10 ? '0' + day : day)
      dateText = dateText + ' ' + (hour < 10 ? '0' + hour : hour) + ':' + (minutes < 10 ? '0' + minutes : minutes) + ':' + (seconds < 10 ? '0' + seconds : seconds)
      return dateText
    },
    getBuriedPointInfo: function () {
      if (!this.module) {
        return
      }

      let params = {
        module: this.module
      }

      let listener = {
        success: (dataInfo) => {
          if (dataInfo.datas && dataInfo.datas.length) {
            this.options = dataInfo.datas
            this.position = 0

            let option = this.options[0]
            this.$refs['mobile'].go(option.nativeLocation)

            this.findBuriedPointEventDatas()
          } else {
            this.position = null
            this.options = []
          }
        }
      }

      sysModel.getBuriedPointInfo(this, params, listener)
    },

    findBuriedPointEventDatas: function () {
      this.charsLoading = true

      let _this = this
      let params = {
        module: this.module
      }

      let position = this.position

      if (this.options.length == 0) {
        return
      }

      let option = this.options[position]

      if (option.event) {
        params.event = option.event
      }

      if (option.xPath) {
        params.xPath = option.xPath
      }

      if (option.location) {
        params.location = option.location
      }

      if (this.createTime && this.createTime[0]) {
        params.startTime = this.getDateTimeByUnixTime(this.createTime[0].getTime())
        params.endTime = this.getDateTimeByUnixTime(this.createTime[1].getTime())
      }

      let listener = {
        success: (dataInfo) => {
          _this.charsLoading = false
          let datas = dataInfo.datas

          let counts = []
          for (var i = 0; i < this.times.length; i++) {
            let time = this.times[i]
            let count = 0
            for (var j = 0; j < datas.length; j++) {
              let item = datas[j]
              if (item._id == time) {
                count = item.count
                break
              }
            }
            counts.push(count)
          }

          _this.datas = counts

          _this.init('clue-data-trend-pic')
        },
        error: (e) => {
          _this.charsLoading = false
        }
      }

      sysModel.findBuriedPointEventDatas(this, params, listener)
    },
    filter: function (datas) {
      let counts = []
      for (var i = 0; i < this.times.length; i++) {
        let time = this.times[i]
        let count = 0
        for (var j = 0; j < datas.length; j++) {
          let item = datas[j]
          if (item._id == time) {
            count = item.count
            break
          }
        }
        counts.push(count)
      }

      this.datas = counts
    },
    init: function (id) {
      let _this = this
      let dom = document.getElementById(id)
      this.chart = echarts.init(dom)

      var colors = ['#5793f3', '#d14a61', '#675bba']

      let option = {
        tooltip: {
          trigger: 'axis'
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        toolbox: {
          feature: {
            dataView: {}
          }
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: this.times
        },
        yAxis: {
          type: 'value'
        },
        series: [{
          type: 'line',
          stack: '总量',
          smooth: true,
          data: this.datas
        }]
      }
      this.chart.clear()
      this.chart.setOption(option)
    },
    getXAxis: function (filters) {
      var tab = filters.tab
      var startTime = new Date(filters.startTime)
      var endTime = new Date(filters.endTime)

      var length = parseInt((endTime.getTime() - startTime.getTime()) / (1000 * 24 * 60 * 60) + 1)

      var xAxis = new Array(length)
      xAxis[0] = this.getMonthTimeByUnixTime(startTime)
      for (var i = 1; i < length; i++) {
        startTime.setDate(startTime.getDate() + 1)
        xAxis[i] = this.getMonthTimeByUnixTime(startTime)
      }

      return xAxis
    },
    getMonthTimeByUnixTime: function (localeDate, format = '-') {
      let year = localeDate.getFullYear()
      let month = localeDate.getMonth() + 1
      let day = localeDate.getDate()
      // let hour = localeDate.getHours()
      // let minutes = localeDate.getMinutes()
      // let seconds = localeDate.getSeconds()
      let dateText = year + '-' + (month < 10 ? '0' + month : month) + format + (day < 10 ? '0' + day : day)
      // dateText = dateText + ' ' + (hour < 10 ? '0' + hour : hour) + ':' + (minutes < 10 ? '0' + minutes : minutes) + ':' + (seconds < 10 ? '0' + seconds : seconds)
      return dateText
    }
  }
}

</script>
